/**
 * Type of entity enveloping process of approving of all documents related to this approving entity
 */
export type DocsApprovingEntityType = (typeof DocsApprovingEntityType)[keyof typeof DocsApprovingEntityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocsApprovingEntityType = {
  EXTERNAL_DOCUMENTS: 'EXTERNAL_DOCUMENTS',
  ORDER_WITHOUT_CR: 'ORDER_WITHOUT_CR',
  ORDER_WITH_CR: 'ORDER_WITH_CR',
} as const;
